import { memo, useMemo } from 'react';
import { Marker } from '@adamscybot/react-leaflet-component-marker';
import { Tooltip } from '@ds';
import { AircraftIcon, MapPointIcon } from '@icons';
import { FboMarkerType } from '@lp/features/RoutePlanner/types';
import { getIconMapColor } from '@lp/features/RoutePlanner/utils';

export const FboMarker = memo(({ location, type, title }: FboMarkerType) => {
  const icon = useMemo(() => {
    const color = getIconMapColor(type);
    const tooltipContent = <span className="text-s-sb">{title}</span>;

    return (
      <Tooltip
        closeDelay={0}
        placement="top"
        showArrow
        content={tooltipContent}
        classNames={{
          base: 'group',
          content: 'shadow-xl opacity-90',
        }}
      >
        <div className="relative flex flex-col justify-center items-center -translate-y-1/3">
          <div className="relative mt-0.5 overflow-hidden" style={{ color }}>
            <MapPointIcon />
            <span className="w-full font-secondary text-center absolute top-1 left-[5px] text-base-90 text-s-sb">
              <AircraftIcon />
            </span>
          </div>
          <div
            className="box-border w-3 h-3 rounded-full border-3 bg-white border-base-25"
            style={{ borderColor: color }}
          />
        </div>
      </Tooltip>
    );
  }, [type, title]);

  return (
    <Marker
      position={location}
      zIndexOffset={10}
      componentIconOpts={{
        disableClickPropagation: true,
      }}
      icon={icon}
    />
  );
});
